module.exports = __webpack_public_path__ + "img/Group 462.9e4aacc4.png";